import { useEffect, useReducer, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "antd";
import "./SwitchClientActions.css";
import { Link } from "react-router-dom";

const SwitchClientActions  = (params: any) => {
  const { t } = useTranslation();

  //popover vars --------
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };


  const handleOpenChange = (newOpen:any) => {
    setOpen(newOpen);
  };

  const content = (
    <div className="actionBtns-container">
     <Link className="pd-md text-black" key={params.rowData.Client_Id} to={"/CreateClient"} state={params.rowData}><div>Create Env</div></Link>
     <Link className="pd-md text-black" key={params.rowData.Client_Id} to={"/DeploymentStatus"} state={params.rowData}>Deployment Status</Link>
    </div>
  );


  return (
    <>
      
      <Popover
        content={content}
        placement="bottomLeft"
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        <div className="header-3dots-icon primary-color" >
        <FontAwesomeIcon
          className="create-icon"
          icon={["fas", "ellipsis-vertical"]}
          size="xl"
        />
      </div>
      </Popover>
    </>
  );
};

export default SwitchClientActions ;
